<template>
	<Loading v-if="!status" />
	<div v-else-if="status === 200">
		<Campaign :campaign="campaign" class="campaign" :hide="['add']" />
		<AdminSubmissionForm
			ref="form"
			:campaign="campaign"
			:loading="submitting"
			@submit="onSubmit"
			@cancel="onCancel"
		/>
	</div>
	<Card v-else>
		<h2>Something went wrong, please try again.</h2>
	</Card>
</template>

<script>
import api from '@/mixins/api'
import toast from '@/mixins/toast'
import Loading from '@/components/shared/Loading'
import Campaign from '@/components/admin/Campaign'
import Card from '@/components/shared/Card'
import AdminSubmissionForm from '@/components/admin/AdminSubmissionForm'

export default {
	name: 'AddCampaignSubmission',
	data() {
		return {
			status: 0,
			submitting: false,
			campaign: null
		}
	},
	computed: {
		id() {
			return this.$route.params.id
		}
	},
	methods: {
		populate() {
			if (this.campaign !== null) {
				this.$refs.form.populate(this.campaign)
			}
		},
		async onSubmit(body) {
			// Update campaign
			this.submitting = true
			try {
				// Update the campaign
				await this.post('/submissions', { body })
				this.toast('Successfully *added* the submission.')

				// Clear the form for reuse
				const form = this.$refs.form
				if (form && this.campaign) form.init()
			} catch (err) {
				// Show toast with relevant error
				switch (err.name) {
					case 'APIValidationError':
						this.toastWarn('Please check the submission and try again.')
						break
					default:
						this.toastErr(
							'Failed to add the submission. Please try again later.'
						)
						break
				}
			}
			this.submitting = false
		},
		onCancel() {
			this.$router.go(-1)
		}
	},
	async created() {
		try {
			const res = await this.get(`/campaigns/${this.id}`)
			if (res.ok) {
				this.campaign = await res.json()
				this.status = res.status
			}
		} catch (err) {
			const status = err.status || 500
			if (status === 404) {
				this.toastErr(`Campaign with ID ${this.id} not found.`)
				this.$router.replace({ name: 'Manage Campaigns' })
			} else {
				this.status = status
			}
		}
	},
	mixins: [api, toast],
	components: {
		Loading,
		Campaign,
		Card,
		AdminSubmissionForm
	}
}
</script>

<style lang="scss">
.campaign {
	margin-bottom: 3rem;
}
</style>
